import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { ErrorText } from "../components/ErrorText";
import type { DataStore, Workshop } from "../data";

export function CreateWorkshop({ store, onCreated }: { store: DataStore; onCreated: (w: Workshop) => void }) {
  const { t, i18n } = useTranslation();
  const [name, setName] = useState("");
  const [error, setError] = useState<unknown>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      onCreated(await store.createWorkshop(name.trim(), i18n.language));
    } catch (err) {
      setError(err);
    }
  };
  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <h1>{t("workshop.createTitle")}</h1>
        <p>{t("workshop.createIntro")}</p>
        <label className="field wide">
          <span>{t("workshop.name")}</span>
          <input required value={name} onChange={(e) => setName(e.target.value)} aria-label={t("workshop.name")} autoFocus />
        </label>
        <ErrorText error={error} />
        <button type="submit" className="primary">{t("workshop.create")}</button>
      </form>
    </div>
  );
}
